// Matches app/src/theme.ts. Duplicated rather than shared because the native
// side uses these as values passed to RN styles; the web uses them via CSS
// variables (see index.css) and a few inline styles.
export const colors = {
  bg: '#17161c',
  surface: '#24222b',
  surfaceAlt: '#1e1d24',
  text: '#ece5d3',
  textMuted: '#a69f8f',
  accent: '#e8823a',
  accentDim: '#b96a2e',
  alt: '#7d8a6a',
  error: '#f4a5a5',
  danger: '#e5695a',
  divider: '#2f2d37',
} as const;
